(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alp-announcebar-flash"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // init alp-announcebar-new-flash-slider-1-swiper swiper vertical
    new Swiper('.alp-announcebar-new-flash-slider-1-swiper', {
      //   direction: 'vertical',
      rewind: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
      speed: 600,
      effect: 'creative',
      creativeEffect: {
        prev: {
          opacity: 0,
          origin: 'top center',
          translate: [0, 0, 0],
          rotate: [100, 0, 0],
        },
        next: {
          opacity: 0,
          origin: 'bottom center',
          translate: [0, 0, 0],
          rotate: [-100, 0, 0],
        },
      },
    });
    // init alp-announcebar-new-flash-slider-2-swiper swiper vertical
    new Swiper('.alp-announcebar-new-flash-slider-2-swiper', {
      //   direction: 'vertical',
      rewind: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
      speed: 600,
      effect: 'creative',
      creativeEffect: {
        prev: {
          opacity: 0,
          origin: 'top center',
          translate: [0, 0, 0],
          rotate: [100, 0, 0],
        },
        next: {
          opacity: 0,
          origin: 'bottom center',
          translate: [0, 0, 0],
          rotate: [-100, 0, 0],
        },
      },
    });
    // close alp-announcebar-flash-close-btn
    document.querySelectorAll('.alp-announcebar-flash-close-btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        btn.parentElement.style.display = 'none';
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alp-announcebar-new"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // init alp-announcebar-new-slider-1-swiper swiper vertical
    new Swiper('.alp-announcebar-new-slider-1-swiper', {
      //   direction: 'vertical',
      rewind: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
      speed: 600,
      effect: 'creative',
      creativeEffect: {
        prev: {
          opacity: 0,
          origin: 'top center',
          translate: [0, 0, 0],
          rotate: [100, 0, 0],
        },
        next: {
          opacity: 0,
          origin: 'bottom center',
          translate: [0, 0, 0],
          rotate: [-100, 0, 0],
        },
      },
    });
    // init alp-announcebar-new-slider-2-swiper swiper vertical
    new Swiper('.alp-announcebar-new-slider-2-swiper', {
      //   direction: 'vertical',
      rewind: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
      speed: 600,
      effect: 'creative',
      creativeEffect: {
        prev: {
          opacity: 0,
          origin: 'top center',
          translate: [0, 0, 0],
          rotate: [100, 0, 0],
        },
        next: {
          opacity: 0,
          origin: 'bottom center',
          translate: [0, 0, 0],
          rotate: [-100, 0, 0],
        },
      },
    });
    // init alp-announcebar-new-slider-3-swiper swiper vertical
    new Swiper('.alp-announcebar-new-slider-3-swiper', {
      //   direction: 'vertical',
      rewind: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
      speed: 600,
      effect: 'creative',
      creativeEffect: {
        prev: {
          opacity: 0,
          origin: 'top center',
          translate: [0, 0, 0],
          rotate: [100, 0, 0],
        },
        next: {
          opacity: 0,
          origin: 'bottom center',
          translate: [0, 0, 0],
          rotate: [-100, 0, 0],
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alp-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // init alp-announcebar-new-slider-1-swiper swiper vertical
    new Swiper('.alp-announcebar-new-slider-1-swiper', {
      //   direction: 'vertical',
      rewind: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
      speed: 600,
      effect: 'creative',
      creativeEffect: {
        prev: {
          opacity: 0,
          origin: 'top center',
          translate: [0, 0, 0],
          rotate: [100, 0, 0],
        },
        next: {
          opacity: 0,
          origin: 'bottom center',
          translate: [0, 0, 0],
          rotate: [-100, 0, 0],
        },
      },
    });
    // init alp-announcebar-new-slider-2-swiper swiper vertical
    new Swiper('.alp-announcebar-new-slider-2-swiper', {
      //   direction: 'vertical',
      rewind: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
      speed: 600,
      effect: 'creative',
      creativeEffect: {
        prev: {
          opacity: 0,
          origin: 'top center',
          translate: [0, 0, 0],
          rotate: [100, 0, 0],
        },
        next: {
          opacity: 0,
          origin: 'bottom center',
          translate: [0, 0, 0],
          rotate: [-100, 0, 0],
        },
      },
    });
    // init alp-announcebar-new-slider-3-swiper swiper vertical
    new Swiper('.alp-announcebar-new-slider-3-swiper', {
      //   direction: 'vertical',
      rewind: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
      speed: 600,
      effect: 'creative',
      creativeEffect: {
        prev: {
          opacity: 0,
          origin: 'top center',
          translate: [0, 0, 0],
          rotate: [100, 0, 0],
        },
        next: {
          opacity: 0,
          origin: 'bottom center',
          translate: [0, 0, 0],
          rotate: [-100, 0, 0],
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["axx-global-compare-full"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('load', () => {
    class GlobalCompare {
      // checkbox : .global-compare-checkbox with [data-product-id]
      // trigger : [data-global-compare-open] with [data-global-compare-open=' product.id ']
      // options selector : .global-compare-selector
      // options : .global-compare-options with [data-product-id]
      // floating tab: .global-compare-floating-tab

      constructor() {
        // 存储事件处理函数
        this.checkboxs = [];
        this.eventListeners = new Map();
        this.compareParent = document.querySelector('.global-compare');
        this.floatingTab = document.querySelector('.global-compare-floating-tab');
        this.init();
      }

      init() {
        this.removePreloadProducts();
        this.triggerSelectOpen();
        this.updateSelectedProduct();
        this.setSameHeightForItems();
        this.hanldeSelectorChange();
        this.findTheItemsDiff();
        this.triggerOpen();
        this.triggerCompareCheckboxInit();
        this.updateFlotingTabStatus(this.getCookie());
        this.clickFlotingTab();
        window.addEventListener('resize', () => this.setSameHeightForItems());
        window.addEventListener('CompareTrigger', () => this.checkboxEventUpdate());
        this.compareParent.querySelector('.global-compare-diff-trigger').addEventListener('click', () => {
          this.compareParent.classList.toggle('show_diff');
          this.setSameHeightForItems();
        });
      }

      triggerSelectOpen() {
        const globalCompareSelector = document.querySelector('.global-compare-selector span');
        const globalCompareOptions = globalCompareSelector
          .closest('.global-compare-selector')
          .querySelector('.global-compare-options');
        globalCompareSelector.addEventListener('click', () => {
          globalCompareOptions.classList.toggle('hidden');
        });
        document.addEventListener('click', (e) => {
          if (!e.target.closest('.global-compare-selector')) {
            globalCompareOptions.classList.add('hidden');
          }
        });
      }

      updateSelectedProduct() {
        const options = document.querySelectorAll('.global-compare-option');
        options.forEach((option) => {
          option.classList.remove('selected');
        });
        options.forEach((option) => {
          const productId = option.dataset.productId;
          const productEl = this.compareParent.querySelector(
            `.products-new-compare-wrapper [data-product-id="${productId}"]`
          );
          if (productEl) option.classList.add('selected');
        });
      }

      setSameHeightForItems() {
        const rows = document.querySelectorAll(
          '.products-new-compare-wrapper .product-new-compare-i .axx_compare_spec_list'
        );
        const items = rows[0]?.querySelectorAll('.axx_compare_spec_list_item') || [];
        // 重置高度
        rows.forEach((row) => {
          row.querySelectorAll('.axx_compare_spec_list_item').forEach((item) => {
            item.style.setProperty('--height', 'auto');
          });
        });
        // 设置规格高度
        items.forEach((_, index) => {
          let maxHeight = 0;
          rows.forEach((row) => {
            const item = row.querySelectorAll('.axx_compare_spec_list_item')[index];
            maxHeight = Math.max(maxHeight, item.offsetHeight);
          });
          rows.forEach((row) => {
            const item = row.querySelectorAll('.axx_compare_spec_list_item')[index];
            item.style.setProperty('--height', `${maxHeight}px`);
          });
        });
        // 设置图片高度
        const imageWrappers = document.querySelectorAll(
          '.products-new-compare-wrapper .product-new-compare-i .axx-images-with-swatch'
        );
        const maxImageHeight = Math.max(...[...imageWrappers].map((img) => img.offsetHeight), 0);
        imageWrappers.forEach((img) => img.style.setProperty('--height', `${maxImageHeight}px`));
      }

      hanldeSelectorChange() {
        const options = document.querySelectorAll('.global-compare-option');
        options.forEach((option) => {
          option.addEventListener('click', () => {
            const productId = option.dataset.productId;
            option.classList.toggle('selected');
            option.classList.contains('selected') ? this.addProduct(productId) : this.removeProduct(productId);
          });
        });
      }

      removePreloadProducts() {
        this.compareParent
          .querySelectorAll('.products-new-compare-wrapper .product-new-compare-item[data-product-id]')
          .forEach((el) => el.remove());
      }

      async addProduct(ids) {
        // 处理多id输入并去重
        const idArray = Array.isArray(ids)
          ? ids
          : ids
              .toString()
              .split(',')
              .filter((id) => id.trim() !== '');
        const uniqueIds = [...new Set(idArray)];
        const fetchUrl = this.compareParent.dataset.fetchUrl;
        this.compareParent.classList.add('loading');
        // compare ids and the existing products `.product-new-compare-item[data-product-id="${id}"]`
        const existingProducts = this.compareParent.querySelectorAll('.product-new-compare-item[data-product-id]');
        const existingIds = [...existingProducts].map((el) => el.dataset.productId);
        const newIds = uniqueIds.filter((id) => !existingIds.includes(id));
        if (newIds.length === 0) {
          this.compareParent.classList.remove('loading');
          this.compareParent.classList.remove('first-load');
          return;
        }
        // continue to add products
        try {
          const response = await fetch(fetchUrl);
          const responseText = await response.text();
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceParents = html.querySelectorAll('.products-new-compare-wrapper');
          const targetWrappers = this.compareParent.querySelectorAll('.products-new-compare-wrapper');
          // 遍历每个唯一id添加产品
          uniqueIds.forEach((id) => {
            sourceParents.forEach((sourceEl, index) => {
              const targetEl = targetWrappers[index];
              if (!targetEl) return;
              const exitProductEl = targetEl.querySelector(`.product-new-compare-item[data-product-id="${id}"]`);
              // if (exitProductEl) exitProductEl.remove();
              if (exitProductEl) return;
              const productEl = sourceEl.querySelector(`.product-new-compare-item[data-product-id="${id}"]`);
              if (productEl) targetEl.appendChild(productEl);
              const removeEl = productEl.querySelector('.product-compare-remove');
              if (removeEl) this.handleRemoveProductTrigger(removeEl);
            });
          });
        } finally {
          this.findTheItemsDiff();
          this.updateSelectedProduct();
          this.setSameHeightForItems();
          if (window.axxVariantsSwatch) window.axxVariantsSwatch.update();
          this.compareParent.classList.remove('loading');
          this.compareParent.classList.remove('first-load');
          this.setCookie();
          this.updateCheckboxStatus();
        }
      }

      removeProduct(id) {
        this.compareParent
          .querySelectorAll(`.products-new-compare-wrapper [data-product-id="${id}"]`)
          .forEach((el) => el.remove());
        this.findTheItemsDiff();
        this.updateSelectedProduct();
        this.setSameHeightForItems();
        this.setCookie();
        this.updateCheckboxStatus();
      }

      handleRemoveProductTrigger(el) {
        el.addEventListener('click', (e) => {
          e.preventDefault();
          const parent = el.closest('.product-new-compare-item');
          const productId = parent.dataset.productId;
          this.removeProduct(productId);
        });
      }

      setCookie() {
        const uniqueIds = [];
        this.compareParent
          .querySelectorAll('.global-compare-option.selected')
          .forEach((el) => uniqueIds.push(el.dataset.productId));
        // 存储id到cookie（30天过期）
        const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString();
        document.cookie = `selectedIds=${uniqueIds.join(',')}; expires=${expires}; path=/`;
        this.updateFlotingTabStatus(`${uniqueIds.join(',')}`);
      }

      getCookie() {
        // let presetIds = this.compareParent.dataset.presetProducts;
        const cookieValue =
          document.cookie
            .split('; ')
            .find((row) => row.startsWith('selectedIds='))
            ?.split('=')[1] || '';
        if (cookieValue) {
          return cookieValue;
        }
      }

      addIdToCookie(id) {
        let ids = this.getCookie();
        if (!ids) {
          ids = id;
        } else {
          ids = `${ids},${id}`;
        }
        const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString();
        document.cookie = `selectedIds=${ids}; expires=${expires}; path=/`;
        this.updateFlotingTabStatus(ids);
      }

      removeIdFromCookie(id) {
        let ids = this.getCookie();
        if (ids) {
          ids = ids
            .split(',')
            .filter((i) => i !== id)
            .join(',');
          const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString();
          document.cookie = `selectedIds=${ids}; expires=${expires}; path=/`;
          this.updateFlotingTabStatus(ids);
        }
      }

      findTheItemsDiff() {
        document
          .querySelectorAll(
            '.products-new-compare-wrapper.has-compare-data .axx_compare_spec_list .axx_compare_spec_list_item'
          )
          .forEach((item) => {
            item.classList.remove('diff');
          });
        const allRows = document.querySelectorAll(
          '.products-new-compare-wrapper.has-compare-data .axx_compare_spec_list'
        );
        const rows = document.querySelectorAll(
          '.products-new-compare-wrapper.has-compare-data [data-product-id] .axx_compare_spec_list'
        );
        const firstRowItems = rows[0]?.querySelectorAll('.axx_compare_spec_list_item') || [];
        firstRowItems.forEach((_, index) => {
          const values = [...rows].map(
            (row) => row.querySelectorAll('.axx_compare_spec_list_item')[index]?.querySelector('.axcp-desc').textContent
          );
          const hasDiff = new Set(values).size > 1;
          if (hasDiff) {
            allRows.forEach((row) => {
              row.querySelectorAll('.axx_compare_spec_list_item')[index].classList.add('diff');
            });
          }
        });
      }

      triggerCompareCheckboxInit() {
        this.checkboxs = document.querySelectorAll('.global-compare-checkbox');
        if (this.checkboxs.length > 0) {
          this.updateCheckboxStatus();
          this.checkboxs.forEach((checkbox) => {
            const handler = (e) => this.checkboxToggle(checkbox);
            this.eventListeners.set(checkbox, handler);
            checkbox.addEventListener('click', handler);
          });
        }
      }

      checkboxEventUpdate() {
        this.checkboxs.forEach((checkbox) => {
          const handler = this.eventListeners.get(checkbox);
          if (handler) {
            checkbox.removeEventListener('click', handler);
          }
        });
        this.triggerCompareCheckboxInit();
      }

      checkboxToggle(checkbox) {
        const productId = checkbox.dataset.productId;
        if (checkbox.classList.contains('checked')) {
          checkbox.classList.remove('checked');
          this.removeIdFromCookie(productId);
        } else {
          this.addIdToCookie(productId);
        }
        this.updateCheckboxStatus();
      }

      updateCheckboxStatus() {
        let ids = this.getCookie();
        // remove class
        this.checkboxs.forEach((checkbox) => {
          checkbox.classList.remove('checked');
        });
        // update classlist
        if (ids) {
          ids.split(',').forEach((id) => {
            this.checkboxs.forEach((checkbox) => {
              let checkboxId = parseInt(checkbox.dataset.productId);
              if (checkboxId == id) {
                checkbox.classList.add('checked');
              }
            });
          });
          this.updateFlotingTabStatus(ids);
        }
      }

      updateFlotingTabStatus(selectedIds) {
        let floatingTab = this.floatingTab;
        if (!floatingTab) {
          return;
        }
        if (selectedIds) {
          const selectedIdsArray = selectedIds.split(',');
          const selectedIdsCount = selectedIdsArray.length;
          if (selectedIdsCount > 0) {
            floatingTab.classList.add('show');
          } else {
            floatingTab.classList.remove('show');
          }
          floatingTab.querySelector('.compare-products-count').textContent = selectedIdsCount;
        } else {
          floatingTab.classList.remove('show');
        }
      }

      clickFlotingTab() {
        let floatingTab = this.floatingTab;
        if (!floatingTab) {
          return;
        }
        floatingTab.addEventListener('click', (e) => {
          e.preventDefault();
          let ids = this.getCookie() ? this.getCookie() : presetIds;
          if (ids) {
            this.addProduct(ids);
            this.compareParent.classList.remove('hidden');
          }
        });
      }

      triggerOpen() {
        const triggers = document.querySelectorAll('[data-global-compare-open]');
        triggers.forEach((el) => {
          el.addEventListener('click', (e) => {
            e.preventDefault();
            const productId = el.dataset.globalCompareOpen || 'null';
            const productEl = this.compareParent.querySelector(
              `.product-new-compare-item[data-product-id="${productId}"]`
            );
            if (productEl) {
              this.compareParent.classList.remove('hidden');
              this.setSameHeightForItems();
            } else {
              let presetIds = this.compareParent.dataset.presetProducts;
              let ids = this.getCookie() ? this.getCookie() : presetIds;
              if (!ids) {
                ids = productId;
              } else {
                ids = `${ids},${productId}`;
              }
              this.addProduct(ids);
              this.compareParent.classList.remove('hidden');
            }
          });
        });
        const closeTriggers = this.compareParent.querySelectorAll('.global-compare-close, .global-compare-overlay');
        closeTriggers.forEach((el) => {
          el.addEventListener('click', (e) => {
            e.preventDefault();
            this.compareParent.classList.add('hidden');
          });
        });
      }
    }

    window.axxGlobalCompare = new GlobalCompare();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["axx-page-compare"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-list-new"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    $('.faq-new-box .container-pc .faq-box .faq-item .title').click(function () {
      let $this = $(this).parent();
      $this.toggleClass('active').siblings().removeClass('active');
      $this.find('.faq-new-box .container-pc .faq-box .faq-item .faq-list').slideToggle(400);
      $this.siblings().find('.faq-new-box .container-pc .faq-box .faq-item .faq-list').slideUp(400);
    });

    // FAQ折叠功能（事件委托）
    const faqList = document.querySelectorAll('.container-pc .faq-box .faq-item .faq-list');
    faqList.forEach((list) => {
      list.addEventListener('click', (e) => {
        const quest = e.target.closest('.quest');
        if (quest) {
          quest.closest('.item').classList.toggle('active');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-new"] && !Shopify.designMode) return;
  try {
    
  const initFaqNew = (rootDom) => {
    if (!rootDom || rootDom.dataset.faqNewInitialized === 'true') return;
    rootDom.dataset.faqNewInitialized = 'true';

    const searchInput = rootDom.querySelector('.search-input');
    const menuItemList = Array.from(rootDom.querySelectorAll('.container-pc .menu .menu-item'));
    const faqItemList = Array.from(rootDom.querySelectorAll('.container-pc .faq-box .faq-item'));
    const faqItemListReverse = [...faqItemList].reverse();
    const popTips = rootDom.querySelector('.pop-tips');
    const popTipsContent = rootDom.querySelector('.pop-tips .content');
    const searchPlaceholderSpan = rootDom.querySelector('.search-box .placeholder span');
    const searchPlaceholderIcon = rootDom.querySelector('.search-box .placeholder svg');
    const searchResultsTemplate = rootDom.dataset.searchResultsText || 'Es wurden {count} Ergebnisse gefunden';

    let activeTag = 0;
    let inputTimer = null;
    let hideTipsTimer = null;
    let menuSwiper = null;

    const menuEl = rootDom.querySelector('.menu');
    if (menuEl && typeof Swiper !== 'undefined') {
      menuSwiper = new Swiper(menuEl, {
        slidesPerView: 'auto',
      });
    }

    const setActiveTag = (index) => {
      if (!menuItemList.length || index < 0 || index >= menuItemList.length || index === activeTag) return;

      menuItemList[activeTag]?.classList.remove('active');
      menuItemList[index].classList.add('active');
      menuSwiper?.slideTo(index);
      activeTag = index;
    };

    const isContain = (el) => {
      const rect = el.getBoundingClientRect();
      const vWidth = window.innerWidth || document.documentElement.clientWidth;
      const vHeight = window.innerHeight || document.documentElement.clientHeight;

      return !(rect.right < 0 || rect.bottom < 0 || rect.left > vWidth || rect.top > vHeight);
    };

    const showSearchTips = (count) => {
      if (!popTips || !popTipsContent) return;

      popTipsContent.textContent = searchResultsTemplate.replace('{count}', count);
      popTips.hidden = false;
      popTips.classList.remove('pop-tips-hide');
      popTips.classList.add('pop-tips-show');

      clearTimeout(hideTipsTimer);
      hideTipsTimer = setTimeout(() => {
        popTips.classList.remove('pop-tips-show');
        popTips.classList.add('pop-tips-hide');
        setTimeout(() => {
          popTips.classList.remove('pop-tips-hide');
          popTips.hidden = true;
        }, 500);
      }, 5000);
    };

    const searchTitle = (keywords) => {
      const normalizedKeywords = keywords.trim().toLowerCase();
      let activeNum = 0;

      rootDom.querySelectorAll('.container-pc .faq-box .faq-item .faq-list .item').forEach((item) => {
        const title = item.querySelector('.quest')?.innerText.toLowerCase() || '';
        const matched = normalizedKeywords !== '' && title.includes(normalizedKeywords);

        item.classList.toggle('search-actie', matched);
        item.classList.toggle('show-none', normalizedKeywords !== '' && !matched);

        if (matched) activeNum += 1;
      });

      if (activeNum > 0) {
        showSearchTips(activeNum);
      }
    };

    const updateSearchPlaceholder = (hasValue) => {
      if (searchPlaceholderSpan) {
        searchPlaceholderSpan.style.height = hasValue ? '0' : 'auto';
      }
      if (searchPlaceholderIcon) {
        searchPlaceholderIcon.style.display = hasValue ? 'none' : 'block';
      }
    };

    searchInput?.addEventListener('input', () => {
      clearTimeout(inputTimer);
      updateSearchPlaceholder(searchInput.value !== '');

      inputTimer = setTimeout(() => {
        searchTitle(searchInput.value);
      }, 500);
    });

    menuItemList.forEach((item, index) => {
      item.addEventListener('click', () => {
        setActiveTag(index);
      });
    });

    let scrollTick = 0;
    document.addEventListener('scroll', () => {
      if (!faqItemListReverse.length || !menuItemList.length) return;
      if (scrollTick++ % 3 !== 0) return;

      let activeFlag = -1;
      faqItemListReverse.forEach((item, index) => {
        if (isContain(item)) {
          activeFlag = faqItemList.length - index - 1;
        }
      });

      if (activeFlag >= 0) {
        setActiveTag(activeFlag);
      }
    });

    rootDom.querySelectorAll('.container-pc .faq-box .faq-item .faq-list').forEach((list) => {
      list.addEventListener('click', (event) => {
        const quest = event.target.closest('.quest');
        if (quest) {
          quest.closest('.item')?.classList.toggle('active');
        }
      });
    });

    if (typeof $ !== 'undefined') {
      $(rootDom)
        .find('.container-pc .faq-box .faq-item .title')
        .on('click', function () {
          const $item = $(this).parent();
          $item.toggleClass('active');
          // $item.find('.faq-list').slideToggle(400);
          // $item.siblings().find('.faq-list').slideUp(400);
        });
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.faq-new-box').forEach(initFaqNew);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
